@if (field.items.length >= 10) {
  <ng-container>
    <div class="object-view-show-more">
      @if (!field.$$showAll) {
        <button
          mat-stroked-button
          (click)="field.$$showAll = true"
        >
          {{ 'TRANS__OBJECT_VIEW_SHOW_MORE__SHOW_ALL' | translate }}
        </button>
      }
      @else {
        <button
          mat-stroked-button
          (click)="field.$$showAll = false"
        >
          {{ 'TRANS__OBJECT_VIEW_SHOW_MORE__SHOW_LESS' | translate }}
        </button>
      }

      @if (listName) {
        <a
          mat-stroked-button
          [routerLink]="newObjectView ? newListViewRouterLink : '/search/artifact'"
          [queryParams]="{listName: listName}"
          queryParamsHandling="merge"
        >
          {{ 'TRANS__OBJECT_VIEW_SHOW_MORE__OPEN_CONTENT_LIST' | translate }}
        </a>
      }
    </div>
  </ng-container>
}
